import { render } from "./TheFilms.vue?vue&type=template&id=590e11e2&scoped=true"
import script from "./TheFilms.vue?vue&type=script&lang=js"
export * from "./TheFilms.vue?vue&type=script&lang=js"

import "./TheFilms.vue?vue&type=style&index=0&id=590e11e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590e11e2"]])

export default __exports__